import styled from "@emotion/styled";

export const TimeInputRoot = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
